import { render, staticRenderFns } from "./ReportesSiniestros.vue?vue&type=template&id=3cc19d37&"
import script from "./ReportesSiniestros.vue?vue&type=script&lang=js&"
export * from "./ReportesSiniestros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports